/**
 * Shared ReferenceLine rendering for the cartesian chart views. Returns an
 * array (not a wrapper component) — Recharts only honors ReferenceLine as a
 * direct child of the chart element. Status colors, never the palette.
 */
import { ReferenceLine } from 'recharts';
import type { ChartReferenceLine } from '../../types/chartTypes';

const SEVERITY_STROKE: Record<NonNullable<ChartReferenceLine['severity']>, string> = {
  warning: '#f59e0b',
  critical: '#ef4444',
};

export const renderChartReferenceLines = (lines: ChartReferenceLine[] | undefined) =>
  (lines ?? []).map((line, i) => (
    <ReferenceLine
      key={`ref-${i}-${line.value}`}
      y={line.value}
      stroke={line.severity ? SEVERITY_STROKE[line.severity] : 'var(--muted-foreground)'}
      strokeDasharray="4 4"
      ifOverflow="extendDomain"
      label={
        line.label
          ? { value: line.label, position: 'insideTopRight', fontSize: 10, fill: 'currentColor' }
          : undefined
      }
    />
  ));
